<template>
  <ul class="label-box">
    <li v-for="(item, index) in labels"
        :key="index"
        :class="{'label-item': true, active: item.pinyin === curLabel }" >
      <a :href="'/' + origin + '/' + item.pinyin + '/'">
        <h3>{{ item.chinese }}</h3>
      </a>
    </li>
  </ul>
</template>

<script>

  export default {
    name: 'PhotoLabel',
    props: {
      labels: {
        type: Array,
        required: true
      },
      origin: String
    },
    data () {
      return {
        curLabel: this.$route.params.parent
      }
    }
  }

</script>

<style lang="scss" scoped>
  @import "../styles/stylefunc";
  .label-box {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    width: 100%;
    padding: px2rem(5px) 0;
    overflow-x: scroll;
    .label-item {
      flex-shrink: 0;
      width: px2rem(60px);
      height: px2rem(28px);
      margin-bottom: px2rem(5px);
      border-radius: px2rem(20px);
      background-color: #F1F0F6;
      line-height: px2rem(28px);
      text-align: center;
      h3 {
        color: #4a4a4a;
        font-size: px2rem(12px);
      }
    }
    .label-item:not(:last-child) {
      margin-right: px2rem(10px);
    }
    .label-item:hover {
      border: solid 1px #F39;
    }
    .label-item:hover h3 {
      color: #F39;
    }
    .active {
      border: none;
      background-color: #F39;
      h3 {
        color: #FFF;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/components/PhotoLabel.vue